<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="contasreceber"
      :loading="loading"
      item-key="id"
      v-model="selected"
      show-select
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            depressed
            color="accent"
            @click="gerarCnab()"
            v-if="selected.length > 0"
          >
            <v-icon class="mdi mdi-book-plus-multiple-outline mr-2" />Gerar Cnab
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.empresa="{ item }">
        <span class="caption">{{ item.empresa.nome_fantasia }}</span>
      </template>
      <template v-slot:item.cliente="{ item }">
        <span class="caption">{{ strDocumento(item.clientes) }}</span>
        <BR />
        {{ item.clientes.nome }}
      </template>

      <template v-slot:item.data_vencimento="{ item }">
        <span class="caption">{{ dataBR(item.data_vencimento) }}</span>
      </template>

      <template v-slot:item.valor_receber="{ item }">
        <span class="caption">{{ number_format(item.valor_receber) }}</span>
      </template>

      <template v-slot:item.forma_pagamento="{ item }">
        <span class="caption">{{ item.forma_pagamento.descricao }}</span>
      </template>

      <template v-slot:item.situacao="{ item }">
        <span class="caption">{{ infoSituacao[item.situacao] }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import number_format_lib from "../lib/number_format";
import { build } from "../lib/masks";

export default {
  components: {
    DatatableFilters,
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Empresa", value: "empresa" },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Fatura", value: "documento" },
        { text: "Data Vencimento", value: "data_vencimento", sortable: false },
        { text: "Valor (R$)", value: "valor_receber" },
        { text: "Forma Pagamento", value: "forma_pagamento", sortable: false },
        {
          text: "Situação",
          value: "situacao",
          sortable: false,
          align: "center",
        },
      ],
      filters: [
        {
          name: "id_empresa",
          label: "Empresa",
          type: "select",
          options: [],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.gerarcnab") || `{}`
      ),
      loading: false,
      selected: [],
      menu: [],
      infoSituacao: {
        DG: "Digitação",
        AB: "Aberto",
        PG: "Pago",
        CA: "Cancelado",
      },
      crCnab: [],
    };
  },
  computed: {
    ...mapState({
      contasreceber: (state) => state.contasReceber.contasReceber.dados,
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("contasReceber/deletar", id);
      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "contas-receber-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;

      try {
        await this.$store.dispatch("contasReceber/listar", {
          filtros: this.filtrosAtivos,
          CarregarOrigem: false,
          Cnab: true,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de clientees",
        });
      }
      this.loading = false;
    },
    strDocumento(cliente) {
      try {
        if (cliente.tipo === "F") {
          return build.cpf(cliente.cpf_cnpj);
        } else {
          return build.cnpj(cliente.cpf_cnpj);
        }
      } catch (err) {
        console.log(cliente);
        return "*Cliente Excluído*";
      }
    },
    dataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.substr(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    number_format(numero) {
      return number_format_lib(numero);
    },
    async gerarCnab() {
      let jsonCnab = {};
      let verificador = 0;

      const promises = [];
      this.selected.map((cnab) => {
        promises.push(
          this.$store.dispatch("contasReceber/carregarContasReceber", cnab.id)
        );
      });

      try {
        const responses = await Promise.all(promises);
        responses.map((response) => {
          if (verificador == 0) {
            jsonCnab = {
              banco: "341",
              agenciaBanco: response.data.conta_bancaria.agencia,
              contaBanco: response.data.conta_bancaria.conta.substr(0, 5),
              contaDigVer: response.data.conta_bancaria.conta.substr(-1),
              carteira: "109",
              cedente: {
                nome: response.data.empresa.razao_social,
                cpf_cnpj: response.data.empresa.cnpj,
                endereco: response.data.empresa.endereco,
                numero: response.data.empresa.numero,
                bairro: response.data.empresa.bairro,
                cep: response.data.empresa.cep,
                cidade: response.data.empresa.cidade.nome,
                estado: response.data.empresa.cidade.estado.sigla,
              },
              detalhes: [],
            };
          }
          verificador = 1;

          response.data.data_emissao = this.dataBR(
            response.data.data_emissao.substr(0, 10)
          );
          response.data.data_vencimento = this.dataBR(
            response.data.data_vencimento.substr(0, 10)
          );

          jsonCnab.detalhes.push({
            idCR: response.data.id,
            sacado: {
              nome: response.data.clientes.razao_social
                .normalize("NFKD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase(),
              cpf_cnpj: response.data.clientes.cpf_cnpj,
              endereco: response.data.clientes.enderecos[0].endereco
                .normalize("NFKD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase(),
              numero: response.data.clientes.enderecos[0].numero,
              complemento: (
                response.data.clientes.enderecos[0].complemento || ""
              )
                .normalize("NFKD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase(),
              bairro: response.data.clientes.enderecos[0].bairro
                .normalize("NFKD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase(),
              cep: response.data.clientes.enderecos[0].cep,
              cidade: response.data.clientes.enderecos[0].cidade.nome
                .normalize("NFKD")
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase(),
              estado: response.data.clientes.enderecos[0].cidade.estado.sigla,
            },
            dataEmissao: response.data.data_emissao,
            dataVencimento: response.data.data_vencimento,
            valorDocumento: response.data.valor_receber,
            nossoNumero: response.data.sequencia_boleto,
            numeroDocumento: response.data.documento,
          });
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível gerar o arquivo do CNAB",
        });
      }

      let nomeArquivo = "";
      try {
        let info = await this.$store.dispatch("cnab/carregarCnab", jsonCnab);

        let dadosCnab = await this.$store.dispatch(
          "cnab/buscaCnab",
          info.data.data.substr(-11)
        );

        nomeArquivo = info.data.data.substr(-11);

        let text = dadosCnab.data;

        let pom = document.createElement("a");
        pom.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(text)
        );
        pom.setAttribute("download", info.data.data.substr(-11));

        if (document.createEvent) {
          let event = document.createEvent("MouseEvents");
          event.initEvent("click", true, true);
          pom.dispatchEvent(event);
        } else {
          pom.click();
        }
      } catch (err) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível recuperar o arquivo do CNAB",
        });
      }

      try {
        // gravar nome arquivo no CR

        this.selected.map(async (cnab) => {
          let id_cr = cnab.id;

          await this.$store.dispatch("contasReceber/gravar", {
            id: id_cr,
            id_usuario_cnab: this.$store.state.usuarios.usuarioAtivo.id,
            data_hora_cnab: new Date(),
            arquivo_cnab: nomeArquivo,
          });
          this.listar();
        });
        // ====================================
      } catch (err) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível atualizar o CR com o CNAB",
        });
        this.listar();
      }
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.gerarcnab", JSON.stringify(val));
      this.listar();
      this.selected = [];
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Geração de CNAB",
    });

    this.$store.dispatch("empresa/listar", {}).then((empresas) => {
      this.filters.find(
        (f) => f.name === "id_empresa"
      ).options = empresas.data.map((e) => ({
        text: e.nome_fantasia,
        value: e.id,
      }));
    });

    this.listar();
  },
};
</script>
